<script setup>
import {defineProps, ref} from 'vue';

defineProps({
    button: {
        type: Object,
        required: true
    },
    labels: {
        type: Array,
        required: true
    }
});

const isOpen = ref(false);

const toggle = () => {
    isOpen.value = !isOpen.value;
};
</script>

<template>
    <div class="EffectButton" :style="{'left': button.left + 'px', top: button.top + 'px'}">
        <button @click="toggle" >
            <span v-if="isOpen">-</span>
            <span v-else>+</span>
        </button>

        <div v-if="isOpen" class="EffectButton__modal">
            <p v-for="(label, index) in labels" :key="index">{{label}}</p>
        </div>
    </div>
</template>


<style lang="scss" scoped>
.EffectButton {
    position: absolute;

    button {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        font-size: 20px;
        background: rgba(255,255,255,0.8);
        border: 0;
        cursor: pointer;
    }

    &__modal {
        font-size: 14px;
        position: absolute;
        left: 30px;
        top: -10px;
        width: 200px;
        background: #00517C;
        padding: 6px 8px;
        z-index: 10;
        color: #fff;

        p {
            margin: 0 0 10px 0;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
